export var group=function group(array,key){return array.reduce(function(acc,item){(acc[item[key]]=acc[item[key]]||[]).push(item);return acc;},{});};